module.exports = __webpack_public_path__ + "img/color6_on.532abe74.png";